import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {EmailRendererTest} from './email-renderer-test';

@Injectable()
export class EmailRendererTestService {
    constructor(private httpClient: HttpClient) {

    }

    /**
     *
     * @param html
     * @param subject
     */
    public post(html: string, subject: string): Observable<any> {
        return this.httpClient.post<EmailRendererTest>(`https://api.emailonacid.com/v5/email/tests`, {
            html,
            subject
        }, {
            headers: {
                Authorization: `Basic ${btoa('Y1Koj3MKhYfiz5SAgGTBTluRJy3Z8P7nwJjT3UDC:7Fk0G2KVUiRaNnT6sH8v')}`
            }
        }).pipe(map((serializedEmailRendererTest: EmailRendererTest) => {
            return new EmailRendererTest(serializedEmailRendererTest);
        }));
    }
}
